import { useEffect, useState } from 'react';
import {
  pushError,
  pushErrorFromAPI,
  pushSuccess,
} from 'src/utilities/notifications';
import { sdk } from 'src/utilities/sdk';
import {
  SHORT_SEARCH_DELAY,
  useSearch,
  ISearchResults,
  IDiner,
  PAGE_SIZE,
} from 'src/utilities/useSearchHooks';

export async function saveDepartmentName(
  corpId: string,
  departmentId: string,
  newDepartmentName: string
): Promise<boolean> {
  try {
    await sdk.http.put(`/corp-admin/${corpId}/departments/${departmentId}`, {
      owner_id: corpId,
      name: newDepartmentName,
    });
    await new Promise<void>((resolve) => {
      setTimeout(() => {
        pushSuccess(`Your department ${newDepartmentName} has been updated`);
        resolve();
      }, SHORT_SEARCH_DELAY);
    });
  } catch (error) {
    pushError(
      `Your department ${newDepartmentName} was not updated. Try again.`
    );
    return false;
  }
  return true;
}

export const useGetDepartmentName = (
  corpid: string,
  departmentId: string
): string => {
  const [name, setName] = useState<string>(null);

  useEffect(() => {
    if (corpid && departmentId) {
      getDepartmentName();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [corpid, departmentId]);

  async function getDepartmentName() {
    try {
      const { name } = await sdk.http.get(
        `/corp-admin/${corpid}/departments/${departmentId}`
      );

      setName(name);
    } catch (error) {
      pushErrorFromAPI(error, {
        fallbackMessage: `Could not get department name`,
      });
    }
  }

  return name;
};

export function useDepartmentEmployeesSearch(
  corpId: string,
  departmentId: string
): ISearchResults<IDiner> {
  const departmentNameSearchUrl = `/corps/${corpId}/departments/${departmentId}/diners/search`;

  return useSearch<IDiner>(departmentNameSearchUrl, {
    sort_field: 'LAST_NAME',
    sort_order: 'ASC',
    size: PAGE_SIZE,
  });
}
